// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"157":"52029f4f8894460edab4","192":"943ab70a1beac6489dd4","336":"8309848517bd793407d1","538":"e72beae4a76f14820fa0","607":"237b88a9d186588f26ca","662":"7ddc0c10c6e124b8ab77"}[chunkId] + ".min.js";
};